'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$00249 from "./presto.-Login-Page-View$$anon$9.js";
import * as $j_presto$002etypes$0024$002dAccount$002dId$0024 from "./presto.types$-Account-Id$.js";
import * as $j_presto$002etypes$0024$002dEmail$0024 from "./presto.types$-Email$.js";
import * as $j_presto$002etypes$0024$002dMorbid$002dUser$002dDetails$0024 from "./presto.types$-Morbid-User-Details$.js";
var $p;
/** @constructor */
function $c_Lpresto_LoginPageView$$anon$8() {
  this.b7v = null;
  this.b7n = null;
  this.b7o = false;
  this.b7w = null;
  this.b7x = false;
  this.b7A = null;
  this.b7t = null;
  this.b7u = false;
  this.b7p = null;
  this.b7q = false;
  this.b7r = null;
  this.b7s = false;
  this.b7y = false;
  this.b7z = false;
  this.b7v = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.b7A = "MorbidUserDetails";
}
export { $c_Lpresto_LoginPageView$$anon$8 as $c_Lpresto_LoginPageView$$anon$8 };
$p = $c_Lpresto_LoginPageView$$anon$8.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LoginPageView$$anon$8;
/** @constructor */
function $h_Lpresto_LoginPageView$$anon$8() {
}
export { $h_Lpresto_LoginPageView$$anon$8 as $h_Lpresto_LoginPageView$$anon$8 };
$h_Lpresto_LoginPageView$$anon$8.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.b7v;
});
$p.L = (function() {
  if ((!this.b7o)) {
    this.b7n = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.b7o = true;
  }
  return this.b7n;
});
$p.O = (function() {
  if ((!this.b7x)) {
    this.b7w = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.b7x = true;
  }
  return this.b7w;
});
$p.E = (function() {
  return this.b7A;
});
$p.t = (function() {
  if ((!this.b7u)) {
    this.b7t = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("email", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("account", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.b7u = true;
  }
  return this.b7t;
});
$p.M = (function() {
  if ((!this.b7q)) {
    this.b7p = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dEmail$0024.$m_Lpresto_types$Email$().cG(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dAccount$002dId$0024.$m_Lpresto_types$AccountId$().bl(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.b7q = true;
  }
  return this.b7p;
});
$p.Q = (function() {
  if ((!this.b7s)) {
    this.b7r = new $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$00249.$c_Lpresto_LoginPageView$$anon$9();
    this.b7s = true;
  }
  return this.b7r;
});
$p.w = (function() {
  if ((!this.b7z)) {
    this.b7y = false;
    this.b7z = true;
  }
  return this.b7y;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee61) => ((p) => \u03b4scrutinee61.GE(p)))($j_presto$002etypes$0024$002dMorbid$002dUser$002dDetails$0024.$m_Lpresto_types$MorbidUserDetails$())));
});
var $d_Lpresto_LoginPageView$$anon$8 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LoginPageView$$anon$8, "presto.LoginPageView$$anon$8", ({
  Ml: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_LoginPageView$$anon$8 as $d_Lpresto_LoginPageView$$anon$8 };
//# sourceMappingURL=presto.-Login-Page-View$$anon$8.js.map
